import objectPath from 'object-path';
import { settings } from '../../../../settings/settings-util';
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {AnyAction} from "redux";
import {AppendLiveChatHistoryMessageAction} from "../actions/actions";


export default function reduce(state = defaultState, action: AnyAction): AlmeState
{
    const newState = { ...state };
    let stateLocation, message, operatorData, currentOperators;
    const { Base, sessionState, LastSeenIndex } = settings.stateLocations.LiveChat;
    const { livechatQueuedBanner } = settings.messageConstants;

    switch (action.type)
    {
        case 'APPEND_LIVE_CHAT_HISTORY_MESSAGE':
            message = (action as AppendLiveChatHistoryMessageAction).historyMessage;

            return {
                ...state,
                History: {
                    ...state.History,
                    HistoryMessages: [...state.History.HistoryMessages, message],
                },
            };

        case 'OPERATOR_TYPING':
            objectPath.set(newState, action.payload.stateLocation, action.payload.isTyping);

            return newState;

        case 'REMOVE_QUEUE_BANNERS':
            return {
                ...state,
                History: {
                    ...state.History,
                    HistoryMessages: state.History.HistoryMessages.filter(historyMessage => historyMessage.type !== livechatQueuedBanner),
                },
            };

        case 'SAVE_OPERATOR_DATA':
            ({ stateLocation, operatorData } = action.payload);
            currentOperators = objectPath.get(state, stateLocation);
            objectPath.set(newState, stateLocation, [...currentOperators, operatorData]);

            return newState;

        case 'SET_LAST_SEEN_INDEX':
            objectPath.set(newState, action.payload.stateLocation, action.payload.lastSeenIndex);

            return newState;

        case 'SET_QUEUE_TEXT':
            objectPath.set(newState, action.payload.stateLocation, action.payload.text);

            return newState;

        case 'SET_SESSION_ID':
            newState[Base][sessionState] = settings.livechat.sessionState.offline;
            newState[Base][LastSeenIndex] = -1;

            return newState;

        case 'SET_USER_TYPING_STATE':
            objectPath.set(newState, action.payload.stateLocation, action.payload.userTyping);

            return newState;

        case 'UPDATE_CHAT_SESSION_STATE':
            objectPath.set(newState, action.payload.stateLocation, action.payload.sessionState);

            return newState;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/reducers/index.ts